import { Trash2, Plus, ArrowUp, ArrowDown } from 'lucide-react';
import { FONTS } from './brandPresets';

const lbl = 'font-heading text-[10px] tracking-widest uppercase text-muted-foreground';

export function LayerControls({ layer, onChange, onDelete, onOrder, onAddText }) {
  if (!layer) {
    return (
      <div className="space-y-2">
        <p className="text-xs text-muted-foreground">Tap any title, logo or the group on the photo to select it, then drag to move.</p>
        <button onClick={onAddText} data-testid="brand-add-text"
          className="inline-flex items-center gap-1 text-[10px] font-heading tracking-widest uppercase border border-border hover:border-orange-500 px-3 py-1.5 rounded-full"><Plus size={11} /> Add text</button>
      </div>
    );
  }
  const isText = layer.type === 'text';
  return (
    <div className="space-y-3" data-testid="brand-layer-controls">
      {isText && (
        <div>
          <div className={lbl}>Text (Enter = new line)</div>
          <textarea value={layer.text} rows={Math.min(5, layer.text.split('\n').length + 1)} data-testid="brand-text-input"
            onChange={(e) => onChange({ text: e.target.value })}
            className="w-full bg-background border border-border rounded-lg px-3 py-2 text-sm outline-none focus:border-orange-500" />
        </div>
      )}
      <div>
        <div className={lbl}>Size</div>
        <input type="range" data-testid="brand-size-slider" className="w-full accent-orange-500"
          min={isText ? 12 : 40} max={isText ? 260 : 2400} value={isText ? layer.size : layer.w}
          onChange={(e) => onChange(isText ? { size: +e.target.value } : { w: +e.target.value })} />
      </div>
      {isText && (
        <div className="flex flex-wrap items-center gap-2">
          <select value={layer.font} onChange={(e) => onChange({ font: e.target.value })} data-testid="brand-font-select"
            className="bg-background border border-border rounded-lg px-2 py-1 text-xs">
            {FONTS.map((f) => <option key={f} value={f}>{f}</option>)}
          </select>
          <input type="color" value={layer.color} onChange={(e) => onChange({ color: e.target.value })} data-testid="brand-color-input"
            className="w-8 h-8 rounded bg-transparent border border-border" />
          <label className="inline-flex items-center gap-1 text-xs">
            <input type="checkbox" checked={!!layer.stroke} onChange={(e) => onChange({ stroke: e.target.checked })} data-testid="brand-stroke-toggle" /> Outline
          </label>
          <label className="inline-flex items-center gap-1 text-xs">
            <input type="checkbox" checked={!!layer.backdrop} onChange={(e) => onChange({ backdrop: e.target.checked })} data-testid="brand-backdrop-toggle" /> Dark box
          </label>
        </div>
      )}
      <div className="flex gap-2">
        <button onClick={() => onOrder(1)} data-testid="brand-layer-up" title="Bring forward" className="p-1.5 rounded-full border border-border hover:border-orange-500"><ArrowUp size={12} /></button>
        <button onClick={() => onOrder(-1)} data-testid="brand-layer-down" title="Send back" className="p-1.5 rounded-full border border-border hover:border-orange-500"><ArrowDown size={12} /></button>
        <button onClick={onDelete} data-testid="brand-layer-delete"
          className="ml-auto inline-flex items-center gap-1 text-[10px] font-heading tracking-widest uppercase text-red-400 border border-red-500/40 hover:bg-red-600 hover:text-black px-3 py-1 rounded-full"><Trash2 size={11} /> Remove</button>
      </div>
    </div>
  );
}
